import { IconShare } from "@/assets/icons/geist/IconShare";
import { Button } from "@/components/flexkit/Button";
import { useCurrentMember } from "@/hooks/use-current-member";
import { useShareResource } from "@/hooks/use-share-resource";
import { useRunner } from "@/queries/runner-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import { type FC } from "react";

type ShareRunnerButtonProps = {
    runnerId: string;
};

export const ShareRunnerButton: FC<ShareRunnerButtonProps> = ({ runnerId }) => {
    const { openShareDialog } = useShareResource();
    const { data: runner } = useRunner(runnerId);
    const { currentMember } = useCurrentMember();

    // TODO: Enable runner:grant permission check once backend supports it
    // Currently RUNNER_ADMIN role doesn't have sufficient permissions for sharing actions
    // const { value: isGroupManagementEnabled } = useFlagGroupManagementEnabled();
    // const { hasPermission } = useResourcePermissions({ enabled: isGroupManagementEnabled });
    // const canGrantRunner = isGroupManagementEnabled
    //     ? hasPermission(ResourceType.RUNNER, runnerId, "runner:grant")
    //     : isAdmin;
    const isAdmin = currentMember?.role === OrganizationRole.ADMIN;
    const canGrantRunner = isAdmin;

    const handleShareClick = () => {
        if (runner) {
            openShareDialog({
                resourceType: ResourceType.RUNNER,
                resourceId: runner.runnerId,
                resourceName: runner.name || "Untitled Runner",
            });
        }
    };

    if (!canGrantRunner) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleShareClick}
            disabled={!runner}
            data-testid="share-runner-button"
            data-tracking-id="share-runner-button"
            LeadingIcon={IconShare}
            size={"sm"}
        >
            Share
        </Button>
    );
};
